import FormErrors from 'app/utils/form_errors'
import deserialize from 'app/utils/deserialize'
import { fetch, update } from 'app/utils/data'

export default {
  namespaced: true,
  state: { item: null },
  getters: {
    emailData: (state) => state.item
  },
  mutations: {
    emailDataFetched(state, { emailData }) {
      state.item = emailData
    },
    resetState(state) {
      state.item = null
    }
  },
  actions: {
    async fetchEmailDataByAccount({ commit }, accountId) {
      try {
        const response = await fetch({
          url: `/api/admin/email?account_id=${accountId}`,
          type: 'email_data'
        })
        const emailData = await deserialize(response.data)
        commit('emailDataFetched', { emailData })
        return emailData
      } catch (error) {
        throw new FormErrors(error.response?.data?.errors || [])
      }
    },

    async updateEmailDataByAccount({ commit }, { accountId, changes }) {
      try {
        const response = await update({
          url: `/api/admin/email?account_id=${accountId}`,
          patch: true,
          type: 'email_data',
          changes
        })
        const updated = await deserialize(response.data)
        commit('emailDataFetched', { emailData: updated })
        return updated
      } catch (error) {
        throw new FormErrors(error.response?.data?.errors || [])
      }
    }
  }
}
